// extracted by mini-css-extract-plugin
export default {"tableWrapper":"styles_tableWrapper__1Ajfs","tableWrapperItem":"styles_tableWrapperItem__Rz24l"};